import { useFeatureIsOn } from '@growthbook/growthbook-react'

import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

import { useIsClientOfflineBookingAvailable } from '@/src/domains/client-booking/hooks/useIsClientOfflineBookingAvailable'

import { TherapistCardEventTypeUI } from './TherapistCardEventType.ui'

export interface TherapistCardEventTypeProps {
  therapist: TherapistType
}

export const TherapistCardEventType = ({ therapist }: TherapistCardEventTypeProps) => {
  const isOfflineEnabled = useFeatureIsOn('offline-therapy-enable-user-booking')
  const isOfficeAvailable = useIsClientOfflineBookingAvailable({ therapist })

  if (!isOfflineEnabled) {
    return null
  }

  return <TherapistCardEventTypeUI office={isOfficeAvailable ? therapist.office : null} />
}
